



















import Vue from 'vue'
import PublicationTransfer from '@/components/publication-transfer.vue'

export default Vue.extend({
  components: {
    PublicationTransfer,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    context: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    dialog: false,
  }),
  watch: {
    show(newVal) {
      this.dialog = newVal
    },
  },
  methods: {
    close() {
      this.$emit('update:show', false)
    },
    submit() {
      this.$emit('submit')
      this.close()
    },
  },
})
